var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFavouriteStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,23.1c-0.2,0-0.4,0-0.5-0.1C1.5,16.8,0,11.1,0,8.3C0,3.7,3.1,1.5,5.8,1c2.5-0.4,4.8,0.4,6.2,2.1 c1.4-1.7,3.7-2.5,6.2-2.1C20.9,1.5,24,3.7,24,8.3c0,2.8-1.5,8.4-11.5,14.6C12.4,23,12.2,23.1,12,23.1z M7,2.9c-0.3,0-0.6,0-0.9,0.1 C4.1,3.3,2,4.9,2,8.3c0,2.3,1.3,7.1,10,12.6c8.7-5.5,10-10.2,10-12.6c0-3.4-2.1-5-4.1-5.3c-1.8-0.3-4.2,0.3-4.9,2.4 c-0.1,0.4-0.5,0.7-0.9,0.7s-0.8-0.3-0.9-0.7C10.4,3.7,8.7,2.9,7,2.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavouriteStroke);
export default __webpack_public_path__ + "static/media/icon-favourite-stroke.46195358b949b0c9314e24a970bbe366.svg";
export { ForwardRef as ReactComponent };